import styled, { css } from 'styled-components';
import { colors, r4 } from '@ardoq/design-tokens';
import { text2Bold } from '@ardoq/typography';
import { InputStyleProps, PresetIcon, commonInputStyle } from '../../atoms';

export const TextInputStyle = styled.input<
  InputStyleProps & { $hasPrefix?: boolean; $isDisabled?: boolean }
>`
  background-color: ${({ $isDisabled }) =>
    $isDisabled ? colors.surfaceDisabled : colors.surfaceDefault};
  color: ${({ $isDisabled }) =>
    $isDisabled ? colors.textDisabled : colors.textDefault};
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      &::placeholder {
        color: ${colors.textDisabled};
      }
    `}

  &:read-only {
    background-color: ${colors.surfaceStatusNeutral};
    color: ${colors.textDefault};
  }

  position: relative;
  ${commonInputStyle};
  text-align: ${({ $alignText }) => $alignText};
  border-radius: ${({ $hasPrefix, $hasPostfix }) =>
    `${$hasPrefix ? 0 : r4} ${$hasPostfix ? 0 : r4} ${$hasPostfix ? 0 : r4} ${
      $hasPrefix ? 0 : r4
    }`};
`;

// Exceptional case. Normally you should use
// <IconButton /> for clickable icons, but here
// We have icon placed inside the input field
export const ClickableIcon = styled(PresetIcon)`
  && {
    cursor: pointer;
    pointer-events: auto;
    &:hover {
      color: ${colors.iconActionHover};
    }
  }
`;

const Msg = styled.div<{ $isDisabled?: boolean }>`
  ${text2Bold};
  white-space: nowrap;
  background-color: ${({ $isDisabled }) =>
    $isDisabled ? colors.surfaceDisabled : colors.surfaceDefaultSubtle};
  padding: 7px;
  color: ${({ $isDisabled }) =>
    $isDisabled ? colors.textDisabled : colors.textDefault};
  box-shadow: inset 0px 0px 0px 1px ${colors.borderAction};
`;

export const PrefixMsg = styled(Msg)`
  border-radius: ${r4} 0 0 ${r4};
`;

export const PostfixMsg = styled(Msg)`
  border-radius: 0 ${r4} ${r4} 0;
`;
